import { Typography, Stack, Grid } from '@mui/material';
import useDeviceDetect from 'hooks/useDeviceDetect';
import i18next from 'i18next';

import { Languages } from 'enums/languages.enum';

import css from './HowItWorksAlternate.module.css';
import { useTranslation } from 'hooks/useTranslation';

const HowItWorksAlternate = () => {
    const { t, i18n, detect } = useTranslation();
    const { isExtraLargeDesktop } = useDeviceDetect();
    const isMobile = !isExtraLargeDesktop;
    const isEnglish = i18n.language === 'EN';

    return (
        <Stack
            id={'how_it_works'}
            direction={'column'}
            alignItems="center"
            sx={{ paddingTop: isMobile ? '40px' : '100px', paddingBottom: isMobile ? '60px' : '100px', backgroundColor: '#F6F8FC' }}
        >
            <Stack direction={'column'} justifyContent="center" alignItems="center" sx={{ width: '100%', maxWidth: isMobile ? '390px' : '1079px' }}>
                <Typography
                    alignSelf={'flex-start'}
                    sx={{
                        marginBottom: isMobile ? '40px' : '80px',
                        ml: '20px',
                        mr: '20px',
                        fontSize: '38px',
                        fontWeight: '700',
                        background: 'linear-gradient(165deg, #0A2693 0%, #01CFFE 50%, #F2D3CD 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        lineHeight: i18next.language === Languages.fr.toUpperCase() ? '1.1' : '1.5',
                    }}
                >
                    {t('How it works')}
                </Typography>

                {isMobile ? (
                    <Stack direction={'column'} alignItems={'center'} sx={{ padding: detect.isArabicLanguage ? '0 84px 0 0' : '0 0 0 84px' }}>
                        <Stack
                            className={`${css.mobile_grid} ${css.rtl}`}
                            direction={'column'}
                            spacing="50px"
                            alignItems={'flex-start'}
                            sx={{ maxWidth: { xs: detect.isArabicLanguage ? '80%' : 'unset', lmd: 'unset' } }}
                        >
                            <Stack direction={'column'} spacing="32px" alignItems={'flex-start'} minWidth="225px">
                                <Stack direction={'column'} spacing="14px">
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25', whiteSpace: 'pre-line' }}>
                                        {t('how_it_works_alternate_p1')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            width: isEnglish ? '100%' : '90%',
                                            whiteSpace: isEnglish ? 'pre-line' : 'normal',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p2')}
                                    </Typography>
                                </Stack>
                                <img src={'/images/phone-image1.png'} width={'200px'} height={'228px'} alt="" />
                            </Stack>
                            <Stack direction={'column'} spacing="32px" alignItems={'flex-start'} minWidth="225px">
                                <Stack direction={'column'} spacing="14px" width="100%">
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25', whiteSpace: 'pre-line' }}>
                                        {t('how_it_works_alternate_p3')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            width: isEnglish ? '100%' : '90%',
                                            whiteSpace: isEnglish ? 'pre-line' : 'normal',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p4')}
                                    </Typography>
                                </Stack>
                                <img src={'/images/phone-image2.png'} width={'200px'} height={'228px'} alt="" />
                            </Stack>
                            <Stack direction={'column'} spacing="32px" alignItems={'flex-start'} minWidth="225px">
                                <Stack direction={'column'} spacing="14px" width="100%">
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25', whiteSpace: 'pre-line' }}>
                                        {t('how_it_works_alternate_p5')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            width: isEnglish ? '100%' : '90%',
                                            whiteSpace: isEnglish ? 'pre-line' : 'normal',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p6')}
                                    </Typography>
                                </Stack>
                                <img src={'/images/phone-image3.png'} width={'200px'} height={'228px'} alt="" />
                            </Stack>
                        </Stack>
                    </Stack>
                ) : (
                    <Grid className={css.grid} container rowGap={'105px'}>
                        <Grid item xs={6}>
                            <Stack justifyContent="center" alignItems="flex-start" sx={{ height: '100%' }}>
                                <img src={'/images/phone-image1.png'} width={'351px'} height={'400px'} alt="" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack justifyContent="center" alignItems="flex-end" sx={{ height: '100%' }}>
                                <Stack direction={'column'} spacing="14px" width={'310px'}>
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25' }}>
                                        {t('HowItWorkCard_1_title')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            maxWidth: { xs: '90%', lmd: '100%' },
                                            whiteSpace: 'pre-line',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p2')}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack
                                justifyContent="center"
                                alignItems={detect.isArabicLanguage ? 'flex-end' : 'flex-start'}
                                sx={{ marginLeft: '76px', height: '100%' }}
                            >
                                <Stack direction={'column'} spacing="14px">
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25', whiteSpace: 'pre-line' }}>
                                        {t('how_it_works_alternate_p3')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            maxWidth: { xs: '90%', lmd: '100%' },
                                            whiteSpace: 'pre-line',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p4')}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack justifyContent="center" alignItems="flex-end" sx={{ height: '100%' }}>
                                <img src={'/images/phone-image2.png'} width={'351px'} height={'400px'} alt="" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack justifyContent="center" alignItems="flex-start" sx={{ height: '100%' }}>
                                <img src={'/images/phone-image3.png'} width={'351px'} height={'400px'} alt="" />
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack justifyContent="center" alignItems="flex-end" sx={{ height: '100%' }}>
                                <Stack direction={'column'} spacing="14px" width={'310px'}>
                                    <Typography sx={{ color: '#0C0F21', fontSize: '28px', fontWeight: '700', lineHeight: '1.25', whiteSpace: 'pre-line' }}>
                                        {t('how_it_works_alternate_p5')}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#72789A',
                                            fontSize: '16px',
                                            fontWeight: '300',
                                            lineHeight: '1.25',
                                            maxWidth: { xs: '90%', lmd: '100%' },
                                            whiteSpace: 'pre-line',
                                        }}
                                    >
                                        {t('how_it_works_alternate_p6')}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                )}
            </Stack>
        </Stack>
    );
};

export default HowItWorksAlternate;
